export default {
    comparison: {
        comparisonOptions: {
            leftType: "itemProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    equals: {
        equalsOptions: {
            leftType: "itemProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    fuzzyMatch: {
        fuzzyMatchOptions: {
            leftType: "itemProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    startsWith: {
        startsWithOptions: {
            prefixType: "itemProperty",
            prefixValue: "itemId",
            fullTextType: "constantValue",
            fullTextValue: ""
        }
    },
    hasValue: {
        hasValueOptions: {
            propertyType: "itemProperty",
            propertyValue: "itemId"
        }
    },
    hasEvent: {
        hasEventOptions: {
            hasEventType: "constantValue",
            hasEventValue: ""
        }
    },
    fullTextSearch: {
        fullTextSearchOptions: {
            searchInType: "itemProperty",
            searchInValue: "itemId",
            searchStringType: "constantValue",
            searchStringValue: "",
        }
    },
    fullTextSearchAnalyzed: {
        fullTextSearchOptions: {
            searchInType: "contextProperty",
            searchInValue: "itemId",
            searchStringType: "constantValue",
            searchStringValue: "",
        }
    }
}